import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

const VerifyPayment = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const orderId = searchParams.get('order_id');
    const token = localStorage.getItem('saas_token');

    const [status, setStatus] = useState('verifying'); // verifying, success, failed
    const [message, setMessage] = useState('');
    const [supportPhone, setSupportPhone] = useState('917976996433'); // Default fallback

    useEffect(() => {
        fetchSupportPhone();
        if (!token) {
            navigate('/login');
            return;
        }

        if (!orderId) {
            setStatus('failed');
            setMessage('Missing order ID in the URL. Please return to the dashboard.');
            return;
        }

        verifyOrder(orderId);
        // eslint-disable-next-line
    }, [orderId, token]);

    const fetchSupportPhone = async () => {
        try {
            const res = await fetch('https://menu.searchisend.in/apimenu/landing_actions.php?action=fetch_contact_settings');
            const data = await res.json();
            if (data.success && data.settings && data.settings.contact_phone) {
                // Strip non-digits from the phone number just in case
                setSupportPhone(data.settings.contact_phone.replace(/\D/g, ''));
            }
        } catch (err) {
            console.error('Failed to fetch contact settings:', err);
        }
    };

    const verifyOrder = async (id) => {
        try {
            const res = await fetch('https://menu.searchisend.in/apimenu/verify_subscription_payment.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ cashfree_order_id: id })
            });

            const data = await res.json();

            if (data.success) {
                setStatus('success');
                setMessage(data.message || 'Payment verified successfully!');
                toast.success('Payment Successful!');
                setTimeout(() => {
                    navigate('/manage_v2_secure_auth/subscription');
                }, 3000);
            } else {
                setStatus('failed');
                setMessage(data.message || 'Payment verification failed with the gateway.');
                toast.error('Payment Verification Failed');
            }
        } catch (error) {
            console.error('Verification Error:', error);
            setStatus('failed');
            setMessage('A network error occurred while verifying your payment. Please try again or contact support.');
            toast.error('Verification Error');
        }
    };

    return (
        <div style={{ width: '100%' }}>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '70vh', padding: '20px' }}>
                <div style={{
                    background: '#fff',
                    padding: '40px',
                    borderRadius: '16px',
                    boxShadow: '0 10px 25px rgba(0,0,0,0.05)',
                    maxWidth: '500px',
                    width: '100%',
                    textAlign: 'center'
                }}>
                    {status === 'verifying' && (
                        <>
                            <div className="loader" style={{
                                border: '4px solid #f3f3f3',
                                borderTop: '4px solid var(--primary-orange)',
                                borderRadius: '50%',
                                width: '60px',
                                height: '60px',
                                animation: 'spin 1s linear infinite',
                                margin: '0 auto 25px auto'
                            }}></div>
                            <h2 style={{ fontSize: '1.8rem', color: '#333', marginBottom: '15px' }}>Verifying Payment</h2>
                            <p style={{ color: '#666', fontSize: '1.1rem' }}>Please do not close this window or refresh the page while we securely verify your transaction.</p>
                            <style>{`
                                @keyframes spin {
                                    0% { transform: rotate(0deg); }
                                    100% { transform: rotate(360deg); }
                                }
                            `}</style>
                        </>
                    )}

                    {status === 'success' && (
                        <>
                            <div style={{
                                width: '80px',
                                height: '80px',
                                borderRadius: '50%',
                                background: '#10b981',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                margin: '0 auto 25px auto',
                                color: '#fff',
                                fontSize: '2.5rem',
                                boxShadow: '0 4px 15px rgba(16, 185, 129, 0.3)'
                            }}>
                                <i className="fas fa-check"></i>
                            </div>
                            <h2 style={{ fontSize: '2rem', color: '#10b981', marginBottom: '15px' }}>Payment Successful!</h2>
                            <p style={{ color: '#555', fontSize: '1.1rem', marginBottom: '25px' }}>{message}</p>
                            <p style={{ color: '#888', fontSize: '0.9rem' }}>Redirecting you back to the dashboard in 3 seconds...</p>
                        </>
                    )}

                    {status === 'failed' && (
                        <>
                            <div style={{
                                width: '80px',
                                height: '80px',
                                borderRadius: '50%',
                                background: '#dc2626',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                margin: '0 auto 25px auto',
                                color: '#fff',
                                fontSize: '2.5rem',
                                boxShadow: '0 4px 15px rgba(220, 38, 38, 0.3)'
                            }}>
                                <i className="fas fa-times"></i>
                            </div>
                            <h2 style={{ fontSize: '2rem', color: '#dc2626', marginBottom: '15px' }}>Verification Failed</h2>
                            <p style={{ color: '#555', fontSize: '1.1rem', marginBottom: '30px', padding: '0 10px' }}>{message}</p>
                            
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                                <button 
                                    onClick={() => navigate('/manage_v2_secure_auth/subscription')}
                                    style={{
                                        padding: '12px 20px',
                                        background: 'var(--primary-orange)',
                                        color: '#fff',
                                        border: 'none',
                                        borderRadius: '8px',
                                        fontSize: '1.1rem',
                                        fontWeight: '600',
                                        cursor: 'pointer',
                                        transition: 'background 0.3s'
                                    }}
                                >
                                    Return to Dashboard
                                </button>
                                <button 
                                    onClick={() => window.open(`https://wa.me/${supportPhone}`, '_blank')}
                                    style={{
                                        padding: '12px 20px',
                                        background: '#f8f9fa',
                                        color: '#4b5563',
                                        border: '1px solid #e5e7eb',
                                        borderRadius: '8px',
                                        fontSize: '1rem',
                                        fontWeight: '500',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '8px'
                                    }}
                                >
                                    <i className="fab fa-whatsapp" style={{ color: '#25D366' }}></i> Contact Support
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default VerifyPayment;
